module.exports = __webpack_public_path__ + "bg.svg?4188ea69c4009a9c211c4de357a77b6f";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/bg.svg
// module id = 948
// module chunks = 27